import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"left":_vm.left,"top":_vm.top,"bottom":_vm.bottom,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c(VIcon,_vm._g(_vm._b({attrs:{"color":_vm.iconColor,"dark":_vm.dark}},'v-icon',_vm.$attrs,false),on),[_vm._v(_vm._s(_vm.icon))])]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }